import { render, staticRenderFns } from "./DisplaySkills.vue?vue&type=template&id=79a3e0e5&lang=pug&"
import script from "./DisplaySkills.vue?vue&type=script&lang=ts&"
export * from "./DisplaySkills.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a3e0e5')) {
      api.createRecord('79a3e0e5', component.options)
    } else {
      api.reload('79a3e0e5', component.options)
    }
    module.hot.accept("./DisplaySkills.vue?vue&type=template&id=79a3e0e5&lang=pug&", function () {
      api.rerender('79a3e0e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DisplaySkills.vue"
export default component.exports